import { useCallback, useEffect, useState } from 'react';
import {
  fetchPlantProtectionStats,
  subscribePlantProtectionStats
} from '../utils/plantProtectionStatsCache';

/**
 * 三端统一生产 KPI：进行中作业 / 未处理预警 / 在种作物
 * @param {'cockpit'|'farm'|'protection'} scope
 */
export function usePlantProtectionUnifiedStats(scope = 'protection') {
  const [kpis, setKpis] = useState({
    inProgressOperations: 0,
    unresolvedWarnings: 0,
    activeCrops: 0,
    dataRefTime: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(
    async (force = true) => {
      setLoading(true);
      setError(null);
      try {
        const entry = await fetchPlantProtectionStats(scope, { force });
        setKpis(entry.kpis);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    },
    [scope]
  );

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchPlantProtectionStats(scope)
      .then((entry) => {
        if (!cancelled) setKpis(entry.kpis);
      })
      .catch((e) => {
        if (!cancelled) setError(e);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [scope]);

  useEffect(() => {
    return subscribePlantProtectionStats(() => {
      // invalidate 已清空 cache；此处 force 拉取一次即可，勿在 fetch 成功后再 notify
      reload(true);
    });
  }, [reload]);

  return { kpis, loading, error, reload };
}

export default usePlantProtectionUnifiedStats;
